import { theme } from "antd";
import { CSSProperties, ReactNode } from "react";
import { Hover } from "./Hover";

export function VzblCard(props: {
  header?: ReactNode;
  icon?: ReactNode;
  highbrow?: ReactNode | string;
  title?: ReactNode | string;
  description?: ReactNode | string;
  footer?: ReactNode | string;
  style?: CSSProperties;
  hoverStyle?: CSSProperties;
  onClick?: () => void;
}) {
  const { token } = theme.useToken();
  return (
    <Hover
      baseStyle={{
        position: "relative",
        borderColor: token.colorBorderSecondary,
        borderRadius: 5,
        minWidth: 240,
        maxWidth: 320,
        ...props.style,
      }}
      hoverStyle={props.hoverStyle}
    >
      <div
        style={{ border: `1px solid ${token.colorBorderSecondary}` }}
        onClick={props.onClick}
      >
        {props.header && (
          <div
            style={{ borderBottom: `1px solid ${token.colorBorderSecondary}` }}
          >
            {props.header}
          </div>
        )}
        <div
          style={{
            paddingTop: 12,
            paddingBottom: 12,
            paddingLeft: 16,
            paddingRight: 16,
          }}
        >
          {props.icon && <div style={{ marginBottom: 8 }}>{props.icon}</div>}
          {props.highbrow && (
            <div
              style={{
                marginBottom: 2,
                fontSize: 12,
                fontWeight: 400,
                lineHeight: 18,
              }}
            >
              {props.highbrow}
            </div>
          )}
          {props.title && (
            <div style={{ fontSize: 16, fontWeight: 500, lineHeight: "24px" }}>
              {props.title}
            </div>
          )}
          {props.description && (
            <div style={{ fontSize: 14, fontWeight: 400, lineHeight: "20px" }}>
              {props.description}
            </div>
          )}
          {props.footer && (
            <div
              style={{
                position: "absolute",
                bottom: 12,
                left: 16,
              }}
            >
              {props.footer}
            </div>
          )}
        </div>
      </div>
    </Hover>
  );
}
